module.exports = __webpack_public_path__ + "img/photo-team7.d955a645.jpg";